import React from 'react'

import { useLocation, useNavigate, useParams } from 'react-router-dom'

// react-router replacement for v5's withRouter HOC; injects match.params/location/navigate. `any` mirrors the app's other HOCs (arbitrary wrapped component, structurally-read props).
export const withRouter = (Component: React.ComponentType<any>) => {
  const WithRouter = (props: any) => {
    const params = useParams()
    const location = useLocation()
    const navigate = useNavigate()

    return <Component {...props} location={location} match={{ params }} navigate={navigate} />
  }

  WithRouter.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`

  return WithRouter
}

export default withRouter
